export enum ExpenseClassification {
	Food = 0,
	Accommodation = 1,
	Transport = 2,
	MileageRefound = 3,
	Other = 4,
}
